<template>
  <v-container class="pt-0 pr-0">
    <div v-if="!isLoading && hasOwner">
      <v-toolbar flat>
        <v-toolbar-title />
        <v-spacer />

        <account-owner-update-dialog
          :person="model"
          @action="onEdit"
        >
          <template #activator="{ on }">
            <v-btn
              rounded
              outlined
              color="primary"
              v-on="on"
            >
              <v-icon left>
                edit
              </v-icon>
              Update Owner Info
            </v-btn>
          </template>
        </account-owner-update-dialog>
      </v-toolbar>

      <v-divider class="my-3" />

      <v-row>
        <v-col
          cols="12"
          xs="12"
          md="8"
        >
          <info-list
            :list="info"
          />
        </v-col>
      </v-row>
    </div>
    <div v-if="!isLoading && !hasOwner">
      <v-toolbar flat />
      <v-row>
        <v-col cols="12">
          <v-row
            align="center"
            justify="center"
          >
            <div class="d-block body-1">
              Add a person to act as a representative for your account
            </div>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mb-12">
        <v-col cols="12">
          <v-row
            align="center"
            justify="center"
          >
            <account-owner-update-dialog
              :account="{}"
              @action="onEdit"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  rounded
                  outlined
                  color="primary"
                  v-on="on"
                >
                  <v-icon left>
                    add
                  </v-icon>
                  Add person
                </v-btn>
              </template>
            </account-owner-update-dialog>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <v-row v-if="isLoading">
      <v-col cols="12">
        <v-row
          justify="center"
          align="center"
        >
          <v-progress-circular
            :size="125"
            :width="10"
            color="primary"
            indeterminate
          />
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { get, isEmpty } from 'lodash'
import { mapActions } from 'vuex'
import InfoList from '@/components/Common/InfoList.vue'
import AccountOwnerUpdateDialog from "./AccountOwnerUpdateDialog"

export default {
  components: {
    AccountOwnerUpdateDialog,
    InfoList
  },
  props: {
    person: {
      type: Object,
      default: () => ({})
    }
  },
  mounted() {
    this.fetchOwner()
  },
  methods: {
    ...mapActions([ 'getAccountOwner', 'updateAccountOwnerRequirements' ]),
    onEdit(person) {
      this.model = { ...person }
    },
    async fetchOwner() {
      this.isLoading = true

      const owner = await this.getAccountOwner()
        .finally(() => {
          this.isLoading = false
        })

      this.model = owner
    }
  },
  data() {
    return {
      isLoading: false,
      model: {}
    }
  },
  computed: {
    hasOwner() {
      return !isEmpty(this.model)
    },
    info() {
      return [
        {
          label: 'First Name',
          value: get(this.model, 'first_name')
        },
        {
          label: 'Last Name',
          value: get(this.model, 'last_name')
        },
        {
          label: 'Email',
          value: get(this.model, 'email')
        },
        {
          label: 'Phone',
          value: get(this.model, 'phone')
        },
        {
          label: 'Address',
          value: [
            get(this.model, 'address.line1'),
            get(this.model, 'address.line2'),
            `${get(this.model, 'address.city')}, ${get(this.model, 'address.state', '')} ${get(this.model, 'address.postal_code', '')}`,
            get(this.model, 'address.country'),
          ]
        },
        {
          label: 'Date of birth (YYYY-MM-DD)',
          value: `${get(this.model, 'dob.year')}-${get(this.model, 'dob.month')}-${get(this.model, 'dob.day')}`
        },
        {
          label: 'ID Number',
          value: get(this.model, 'id_number_provided') ? 'Provided' : 'Required'
        },
        // {
        //   label: 'ID Document (Front)',
        //   value: 'Required'
        // },
        // {
        //   label: 'ID Document (Back)',
        //   value: 'Required'
        // }
      ]
    },
  },
  watch: {
    account() {
      this.model = this.person
    }
  }
}
</script>
